import React from "react";
import "./Input.css";
import { InputProps } from "./Input.types";

export const InputField: React.FC<InputProps> = ({
  type,
  icon,
  name,
  label,
  value,
  onChange,
  isTextarea,
  isRequired,
  placeholder,
  autoComplete,
}) => {
  return (
    <div className={`flex flex-col ${label && "mb-6"}`}>
      {label && (
        <label className="text-gray-800 font-medium mb-2" htmlFor={name}>
          {label}
        </label>
      )}
      {isTextarea ? (
        <textarea
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 h-[calc(59*0.25rem)] max-md:h-[calc(39*0.25rem)]`}
        />
      ) : (
        <div className="relative">
          <input
            id={name}
            type={type}
            name={name}
            placeholder={placeholder}
            autoComplete={autoComplete}
            value={value}
            required={isRequired}
            onChange={onChange}
            className={`border w-full rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              icon && "pr-10"
            }`}
          />
          <span className="absolute inset-y-0 right-5 flex items-center text-gray 500">
            {icon}
          </span>
        </div>
      )}
    </div>
  );
};
